import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../shared/services/auth.service';
import { ChartDataService } from '../../services/chart-data.service';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-bi',
  templateUrl: './bi.component.html',
  styleUrl: './bi.component.scss',
})
export class BiComponent implements OnInit {
  // Tabs view entitlement
  readonly viewBiRelatedTabs: string[] = ['app.dcr-portal.bi.all'];
  selectedIndex = 0;

  tabs = [
    { name: 'Build Chart', value: 'build-chart', isVisibleForViewOnly: false },
    { name: 'Manage Charts', value: 'manage-charts', isVisibleForViewOnly: true },
    { name: 'Create Dashboard', value: 'create-dashboard', isVisibleForViewOnly: false },
    { name: 'Manage Dashboards', value: 'manage-dashboards', isVisibleForViewOnly: true },
    { name: 'Edit Dashboard', value: 'edit-dashboard', isVisibleForViewOnly: false },
    { name: 'Edit Chart', value: 'edit-chart', isVisibleForViewOnly: false },
    { name: 'View Chart', value: 'view-chart', isVisibleForViewOnly: false },
  ];

  activeTabs?: any[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private chartDataService: ChartDataService,
    public appService: AppService,
  ) {}

  ngOnInit() {
    if (this.appService.isEngagementActive) {
      this.activeTabs = [...this.tabs];
    } else {
      this.activeTabs = this.tabs.filter((tab) => tab.isVisibleForViewOnly);
    }

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      const current = this.activatedRoute.firstChild?.snapshot.url[0]?.path;

      if (current) {
        this.selectedIndex = this.getTabIndexForRoute(current);
      }
      if (current === 'edit-dashboard') {
        this.selectedIndex = this.getTabIndexForRoute('create-dashboard');
      }
      if (current === 'edit-chart' || current === 'view-chart') {
        this.selectedIndex = this.getTabIndexForRoute('build-chart');
      }
    });

    const parentPath = this.activatedRoute.snapshot.url[0]?.path;

    let initial = this.activatedRoute.firstChild?.snapshot.url[0]?.path;

    if (parentPath === 'bi') {
      initial = this.activeTabs[0].value;
    }

    if (initial) {
      this.setIsViewMode(initial);
      this.router.navigate([initial], { relativeTo: this.activatedRoute });
    }
  }

  private getTabIndexForRoute(routePath: string): number {
    return this.activeTabs?.findIndex((tab) => tab.value === routePath) || 0;
  }

  onTabChange(index: number) {
    const currentRoute = this.activatedRoute.firstChild?.snapshot.url[0]?.path;

    const targetRoute = this.activeTabs![index].value;

    this.setIsViewMode(currentRoute!);

    if ((currentRoute === 'edit-chart' || currentRoute === 'view-chart') && targetRoute === 'build-chart') {
      return;
    }

    if (currentRoute === 'edit-dashboard' && targetRoute === 'create-dashboard') {
      return;
    }

    this.router.navigate([targetRoute], { relativeTo: this.activatedRoute });
  }

  setIsViewMode(currentPath: string) {
    if (currentPath === 'view-chart') this.chartDataService.isViewMode = true;
    else this.chartDataService.isViewMode = false;
  }
}
